/*
 * Keepneedle — липка кнопка «в кошик» на телефоні.
 * Свою форму не створює: показує панель, коли справжня кнопка поїхала вгору,
 * і по кліку тисне саме її. Тому варіанти, знижки й застосунки, що чіпляються
 * до форми товару, працюють як працювали.
 */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-kn-sticky]');
    if (!bar) return;

    var realButton = document.querySelector('product-form button[name="add"], form[action*="/cart/add"] button[name="add"]');
    if (!realButton) return;

    var proxy = bar.querySelector('[data-kn-sticky-add]');
    var priceOut = bar.querySelector('[data-kn-sticky-price]');
    var priceSource = document.querySelector('.price__container .price-item--regular, .price__container .price-item--sale');

    proxy.addEventListener('click', function () {
      realButton.click();
    });

    function syncState() {
      var disabled = realButton.hasAttribute('disabled');
      proxy.disabled = disabled;
      proxy.textContent = disabled
        ? (realButton.textContent || '').trim()
        : proxy.dataset.label || proxy.textContent;
    }

    proxy.dataset.label = (proxy.textContent || '').trim();

    function syncPrice() {
      if (!priceSource || !priceOut) return;
      var text = (priceSource.textContent || '').trim();
      if (text) priceOut.textContent = text;
    }

    // Ціну на сторінці ще й перемальовує конвертер валют, тож слухаємо і її:
    // інакше в панелі лишалась ціна у валюті магазину, а на сторінці — у місцевій.
    if (priceSource && 'MutationObserver' in window) {
      new MutationObserver(syncPrice).observe(priceSource.closest('.price__container') || priceSource, {
        subtree: true,
        childList: true,
        characterData: true
      });
    }

    // Кнопка й ціна перемальовуються при зміні варіанта — стежимо за ними.
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        syncState();
        syncPrice();
      }).observe(realButton.closest('product-form, form') || realButton, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['disabled']
      });
    }

    // Показуємо панель тільки коли справжньої кнопки не видно.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { rootMargin: '0px 0px -40px 0px' }
      ).observe(realButton);
    }

    syncState();
    syncPrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

